import {
	getAllLayers,
	restoreLayerVisibility,
	setVisibleLayers,
	type Project,
} from "@/shared/store";
import { useEditorStore } from "@/widgets/editor";
import type { ExportSettings } from "../types";
import { elevationPages } from "./elevationPages";
import { exportLegend } from "./exportLegend";
import { exportPageSpecs } from "./exportPages";
import { planSvg } from "./planSvg";
import { type PrintSvgPage, printSvgDocument } from "./printDocument";

const waitForPaint = () =>
	new Promise<void>((resolve) =>
		requestAnimationFrame(() => requestAnimationFrame(() => resolve())),
	);

const filenameFor = (projectName: string) =>
	projectName.trim().replaceAll(/[<>:"/\\|?*]/g, "_") || "проект";

/** Экспортирует временно показанные в 2D слои и выбранные развёртки в векторный PDF. */
export const downloadPdfExport = async (project: Project, settings: ExportSettings) => {
	const pages: PrintSvgPage[] = [];
	const layerSnapshot = getAllLayers();
	const setPdfExportProgress = useEditorStore.getState().setPdfExportProgress;
	const planPages = exportPageSpecs(project.layers, settings.includeDimensions);
	const showDimensions = useEditorStore.getState().showDimensions;
	const showAreas = useEditorStore.getState().showAreas;
	const planStage = useEditorStore.getState().planStage;

	try {
		useEditorStore.setState({ planStage: "all" });
		for (const [index, page] of planPages.entries()) {
			setPdfExportProgress(`${page.title} · лист ${index + 1} из ${planPages.length}`);
			setVisibleLayers(page.layers);
			useEditorStore.setState({
				showDimensions: page.showDimensions ?? false,
				showAreas: page.wallsOnly ? false : showAreas,
			});
			await waitForPaint();
			pages.push({
				title: page.title,
				svg: planSvg(project.layers, page.markLayers, page.wallsOnly),
				legend: exportLegend(page.legendLayers, project.layers),
			});
		}
		if (settings.includeElevations) pages.push(...elevationPages(project.layers));
		setPdfExportProgress("Открываем диалог печати...");
		printSvgDocument(pages, filenameFor(project.name));
	} finally {
		restoreLayerVisibility(layerSnapshot);
		useEditorStore.setState({ showDimensions, showAreas, planStage });
		setPdfExportProgress(null);
	}
};
